export const purchaseTypes = {
    Regular: 1,
    Promo: 2,
  };